var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-txStatus"},[_c('div',{staticClass:"flex items-center justify-center",class:[
      'status',
      _vm.status === true ? 'success' : 'faild',
      _vm.size === 'small' && 'status-small' ],style:(_vm.statusStyle)},[_c('img',{class:[_vm.size === 'big' ? ' w-4 h-4' : ' w-3 h-3'],attrs:{"src":!_vm.status ? _vm.failIcon : _vm.successIcon,"alt":""}}),_c('div',{style:({
        marginLeft: _vm.size === 'big' ? '4px' : '2px',
      })},[_vm._v(" "+_vm._s(_vm.status === true ? _vm.$t('lang.components.succ') : _vm.$t('lang.components.fail'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }